<template>
  <div id="abilities" class="has-text-centered" v-if="identifier && AbilitiesList && ability">
    <h1 class="title">Ability {{ability.name}}</h1>
    <p class="subtitle">{{ability.description}}</p>

    <template v-if="ability.pokemon.length">
      <h2>Pokemon: {{ability.pokemon.length - ability.pokemonHidden.length}}</h2>
      <div class="list">
        <div class="pokemon" v-for="(p, j) in ability.pokemon" :key="j" v-if="ability.pokemonHidden.indexOf(p) === -1 && pokemonExistsInList(p)">
          <a @click="goPokemon(r.species_identifier)" class="box has-text-centered" v-for="(r, i) in PokemonList" :key="i" v-if="p == r.id">
            <div class="imgwrap">
              <img :src="$pkImg('small', r.identifier, r.id)" alt="" @error="$imgErr($event, 'sprite')">
            </div>
            <span class="id is-hidden">{{$padNumber(r.id, 3)}}</span>
            <span class="identifier is-hidden">{{r.identifier}}</span>
            <span class="species-name title is-size-6">{{r.species_name}}</span>
          </a>
        </div>
      </div>
    </template>

    <template v-if="ability.pokemonHidden.length">
      <h2>Pokemon (Hidden Ability): {{ability.pokemonHidden.length}}</h2>
      <div class="list">
        <div class="pokemon" v-for="(p, j) in ability.pokemonHidden" :key="j + '-hidden'">
          <a @click="goPokemon(r.species_identifier)" class="box has-text-centered" v-for="(r, i) in PokemonList" :key="i" v-if="p == r.id">
            <div class="imgwrap">
              <img :src="$pkImg('small', r.identifier, r.id)" alt="" @error="$imgErr($event, 'sprite')">
            </div>
            <span class="id is-hidden">{{$padNumber(r.id, 3)}}</span>
            <span class="identifier is-hidden">{{r.identifier}}</span>
            <span class="species-name title is-size-6">{{r.species_name}}</span>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import config from '../../../config'
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      paths: config.paths,
    }
  },
  computed: {
    identifier() {
      return this.$route.params.identifier
    },
    ability() {
      return this.AbilitiesList.filter((e) => e.identifier === this.identifier)[0]
    },
    ...mapGetters({
      PokemonList: 'pokemon/list',
      AbilitiesList: 'abilities/list',
    })
  },
  methods: {
    goPokemon(identifier) {
      this.$router.push('/pokemon/' + identifier)
    },
    pokemonExistsInList(pokemonID) {
      for (let i = 0; i < this.PokemonList.length; i++) {
        if (this.PokemonList[i].id === pokemonID) {
          return true
        }
      }
      return false
    }
  },
}
</script>


<style lang="scss">
#abilities {
  .list {
    display: flex;
    flex-flow: row wrap;
    // justify-content: space-between;
    align-items: center;
    justify-content: center;
    .pokemon {
      display: inline-block;
      text-align: center;
      min-width: 100px;
      margin: 10px;
    }
  }
}
</style>

